import platform from 'platform'

import environmentsConfig from './environments.json'

const config = {}

// Tracking
config.analyticsId = 'UA-118705249-1'

// Platform
config.platform = {}
config.platform.product = platform.product
config.platform.os = platform.os.family
config.platform.touch = ['Android', 'iOS', 'Windows Phone'].indexOf(platform.os.family) !== - 1
config.platform.browser = {}
config.platform.browser.name = platform.name.toLowerCase()
config.platform.browser.version = platform.version

// Langs
config.langs = environmentsConfig.langs

// Environment
config.environment = 'prod'

for(const _environment in environmentsConfig.environments)
{
    const domains = environmentsConfig.environments[_environment]

    for(const _domain of domains)
    {
        if(window.location.href.indexOf(_domain) !== -1)
        {
            config.environment = _environment
        }
    }
}

// Domain
config.domain = environmentsConfig.domains[config.environment]

// API
config.api = {}
config.api.url = environmentsConfig.apiUrls[config.environment]
config.api.path = '/wp/wp-json/acf/v3/'

// Videos
config.videos = {}
config.videos.url = environmentsConfig.videosUrls[config.environment]

// Title
config.title = 'Decathlon United'

// Youtube
config.canUseYoutube = true

// // User info
// console.log('Get infos')
// UserInfo.getInfo( // eslint-disable-line no-undef
//     (_data) =>
//     {
//         console.log('_data', _data)
//         if(_data.country.code === 'FR')
//         {
//             config.canUseYoutube = false

//             console.log('config.canUseYoutube', config.canUseYoutube)
//         }
//     },
//     (_error) =>
//     {
//         console.log('_error', _error)
//     }
// )

// Export
export default config



// WEBPACK FOOTER //
// ./src/config/index.js